<template>
  <div class="clientele">
    <section>
      <SectionHeader title="At Location"></SectionHeader>
      <div class='common__section-body gallery__item-container'>
        <div v-bind:key="item.src" class='gallery__item' v-for="item in location" v-on:click='showImage(item.src, item.label)'>
          <img :src="item.src">
          <p>{{item.label}}</p>
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="Our Machinery"></SectionHeader>
      <div class='common__section-body gallery__item-container'>
        <div v-bind:key="item.src" class='gallery__item' v-for="item in machines" v-on:click='showImage(item.src, item.label)'>
          <img :src="item.src">
          <p>{{item.label}}</p>
        </div>
      </div>
    </section>
    <modal name='gallery-image' id='galleryImage' class='gallery__modal'>
      <div class='gallery__modal-content'>
        <img v-bind:src='selectedImage'>
        <label>{{selectedImageLabel}}</label>
        <div class='gallery__modal-close' v-on:click='hideImage'><img src='../assets/images/main/close-icon.png'></div>
      </div>
    </modal>
  </div>
</template>

<style lang="scss">
@import '../sass/_variables.scss';

.gallery__item-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 30px;
}

.gallery__item {
  border-radius: 10px;
  margin: 20px 0;
  min-width: 310px;
  width: calc(33% - 60px);
  overflow: hidden;
  box-shadow: 0px 2px 5px -1px rgba(0, 0, 0, 0.5);

  img {
    width:100%;
    max-height: 250px;
  }

  p {
    margin: 0;
    padding-bottom: 5px;
    text-align: center;
  }
}
.gallery__modal {
  .v--modal {
    height: 90vh !important;
    width: 90vw !important;
    max-height: 600px !important;
    max-width: 900px !important;
    top: 5vh !important;
    left: 0 !important;
    margin: auto;
  }
}
.gallery__modal-content {
  position: relative;
  img {
    width: 100%;
  }
  label {
    display: block;
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
    color: $fc-white;
  }
}
.gallery__modal-close {
  position: absolute;
  right: 10px;
  top: 10px;

  img {
    height: 50px;
    width: 50px;
    cursor: pointer;
  }
}
</style>

<script>
import SectionHeader from '@/components/sectionHeader.vue'

export default {
  name: 'clientele',
  components: {
    SectionHeader,
  },
  methods: {
    showImage: function (image, label) {
      this.selectedImage = image
      this.selectedImageLabel = label
      this.$modal.show('gallery-image')
    },
    hideImage: function (image) {
      this.$modal.hide('gallery-image')
    }
  },
  data: () => ({
    selectedImage: null,
    selectedImageLabel: null,
    location:[{
      src: require('../assets/images/gallery/gallery1.png'),
      label: 'Kolar Power Grid 400 KV Power Station.'
    }, {
      src: require('../assets/images/gallery/gallery2.png'),
      label: 'Kolar Power Grid 400 KV Power Station.'
    }, {
      src: require('../assets/images/gallery/gallery3.png'),
      label: 'Short Circuit Generator CPRI, Bangalore.'
    }, {
      src: require('../assets/images/gallery/gallery4.png'),
      label: 'Hoody 400 KV Station Bangalore'
    }, {
      src: require('../assets/images/gallery/gallery5.png'),
      label: 'Purvankara Apartment'
    }, {
      src: require('../assets/images/gallery/gallery6.png'),
      label: 'Sobha Apartment'
    }, {
      src: require('../assets/images/gallery/gallery7.png'),
      label: 'Sobha Apartment'
    }, {
      src: require('../assets/images/gallery/gallery8.png'),
      label: 'Purvankara Apartment'
    }, {
      src: require('../assets/images/gallery/gallery9.png'),
      label: 'Accenture Bangalore'
    }, {
      src: require('../assets/images/gallery/gallery10.png'),
      label: 'Mantri Apartment'
    }, {
      src: require('../assets/images/gallery/gallery11.png'),
      label: 'Mantri Apartment'
    }, {
      src: require('../assets/images/gallery/gallery12.png'),
      label: 'CPRI BHEL Transformer Oil Filtration'
    }, {
      src: require('../assets/images/gallery/gallery13.png'),
      label: '15KL Exclusive Transformer Oil Tanker'
    }, {
      src: require('../assets/images/gallery/gallery14.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery15.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery16.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery17.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery18.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery19.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery20.png'),
      label: 'KPTCL MUSS'
    }, {
      src: require('../assets/images/gallery/gallery21.png'),
      label: 'Short Circuit Generator CPRI, Bangalore.'
    }],
    machines:[{
      src: require('../assets/images/gallery/machine1.png'),
      label: '6KL Machinery'
    }, {
      src: require('../assets/images/gallery/machine2.png'),
      label: '6KL Ultra High Vacuum Filter Machine'
    }, {
      src: require('../assets/images/gallery/machine3.png'),
      label: '3KL High Vacuum Filter Machine'
    }, {
      src: require('../assets/images/gallery/machine4.png'),
      label: '3KL Filter Machine'
    }, {
      src: require('../assets/images/gallery/machine5.png'),
      label: '15KL Transformer Oil Tanker'
    }, {
      src: require('../assets/images/gallery/machine6.png'),
      label: '6KL Filter Machine'
    }, {
      src: require('../assets/images/gallery/machine7.png'),
      label: 'High Vacuum Pumps'
    }]
  })
}
</script>